import type { RigaPreventivoLetta } from '../../api/preventivi';

/*  Le righe d'articolo che stanno sotto un capitolo, per la stessa nozione di «sotto»
    che usa il conto: il riferimento al padre se c'è, altrimenti la posizione. Due regole
    diverse per dire «sotto quale capitolo sta» farebbero spuntare un capitolo e vedere
    il totale non muoversi.  */
export function discendentiArticolo(
  testa: RigaPreventivoLetta,
  righe: RigaPreventivoLetta[],
): RigaPreventivoLetta[] {
  const figli = new Set<string>([testa.id]);

  //  In ordine di posizione: un discendente sta sempre dopo la sua testa, quindi un giro
  //  solo basta a chiudere tutta la catena.
  const ordinate = [...righe].sort((a, b) => a.posizione - b.posizione);

  for (const r of ordinate) {
    if (r.id === testa.id) continue;
    if (r.rigaPadreId !== null) {
      if (figli.has(r.rigaPadreId)) figli.add(r.id);
      continue;
    }

    //  Senza padre scritto conta l'albero che si vede: la testa più vicina sopra di lei.
    const sopra = ordinate
      .filter((x) => x.livello < r.livello && x.posizione < r.posizione)
      .at(-1);

    if (sopra !== undefined && figli.has(sopra.id)) figli.add(r.id);
  }

  return righe.filter((r) => r.livello === 3 && !r.separatore && figli.has(r.id));
}

/*  L'ULTIMA RIGA DEL BLOCCO DI UNA TESTA, a qualunque livello: e' quella dopo cui va una
    voce che si vuole «in fondo a questo capitolo».

    Chiesto da Galizzi il 15/10/2026: con dieci capitoli, l'articolo nuovo finiva sempre
    nell'ultimo. Il blocco si misura con la stessa regola del conto — riferimento al padre
    se c'e', altrimenti la testa piu' vicina sopra — e comprende sottocapitoli e righe
    vuote: una voce messa prima dello stacco finale starebbe in mezzo al capitolo.  */
export function ultimaDelBlocco(
  testa: RigaPreventivoLetta,
  righe: RigaPreventivoLetta[],
): RigaPreventivoLetta {
  const dentro = new Set<string>([testa.id]);
  const ordinate = [...righe].sort((a, b) => a.posizione - b.posizione);
  let ultima = testa;

  for (const r of ordinate) {
    if (r.posizione <= testa.posizione) continue;

    const padre =
      r.rigaPadreId ??
      ordinate.filter((x) => x.livello < r.livello && x.posizione < r.posizione).at(-1)?.id;

    if (padre !== undefined && dentro.has(padre)) {
      dentro.add(r.id);
      ultima = r;
    }
  }

  return ultima;
}
